import { Component, DoCheck, OnInit, Renderer2 } from "@angular/core";
import { Meta, Title } from "@angular/platform-browser";
import { EventService } from "./services/event.service";
import {
  getParam,
  languages,
  verifyLanguage,
} from "./shared/constants/app-enums";
import { ActivatedRoute, NavigationStart, Router } from "@angular/router";
import { filter } from "rxjs";
import { environment } from "src/environments/environment";
import { ConnectivityService } from "./services/connectivity.service";

declare global {
  interface Window {
    dataLayer: any[];
  }
}
export var selectedLang: string;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit, DoCheck {
  lang: any = "en";
  languagesList: Array<any> = languages;
  showLogin = false;
  authenticateRoute!: string;

  constructor(
    private meta: Meta,
    private title: Title,
    private eventService: EventService,
    private router: Router,
    private route: ActivatedRoute,
    private renderer: Renderer2,
    private connectivityService: ConnectivityService
  ) {
    getParam("clickId");
    getParam("source");
    getParam("tsid");
    getParam("pid");
    this.meta.updateTag({
      name: "description",
      content:
        "Buy and Stake the $WSM token! The $WSM token is the No.1 meme coin of 2023.",
    });
    this.title.setTitle(
      "Buy the $WSM token - Wall Street Memes | The No.1 Meme Community, News & Casino"
    );
    this.eventService.getLang().subscribe((val) => {
      this.lang = val || "en";
      selectedLang = this.lang;
    });
  }

  isRTL() {
    return this.lang == "ar" || this.lang == "fa";
  }

  ngOnInit(): void {
    this.renderer.addClass(document.body, 'dark');
    // this.renderer.addClass(document.body, 'light');
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme === 'dark') {
      this.renderer.addClass(document.body, 'dark');
    }
    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe((event: any) => {
        this.getBrowserDefaultLanguage();
        const routerLang = event.url.toString().split("/")[1];
        if (
          !routerLang ||
          this.languagesList.findIndex(
            (entry: any) => entry.value == routerLang
          ) == -1
        ) {
          this.router.navigateByUrl("/" + selectedLang + event.url);
        }
        this.authenticateRoute = event.url.split('/')?.reverse()[0]?.includes('?') ? event.url.split('/').reverse()[0].split('?')[0] : event.url.split('/').reverse()[0];
        this.checkTestRoute(this.authenticateRoute);
      });
  }

  ngDoCheck(): void {
    this.getBrowserDefaultLanguage();
  }

  getBrowserDefaultLanguage() {
    const localLang = localStorage.getItem("currentlang");
    if (localLang && verifyLanguage(localLang)) {
      selectedLang = localLang;
    } else {
      const userLang = navigator.language?.split("-")[0];
      selectedLang = userLang && verifyLanguage(userLang) ? userLang : "en";
    }
    this.lang = selectedLang;
  }

  /**
   * Checks if route is protected for internal users
   * @param route - current feature route
   */
  checkTestRoute(route: string) {
    // If route is protected, but the user has not authenticated
    if (environment.testFeatureRoutes.includes(route) && localStorage.getItem('authenticatedRoute') !== route) {
      this.showLogin = true;
      localStorage.clear();
    } else if (!environment.testFeatureRoutes.includes(route)) {
    // Else if -> route is unprotected
      this.showLogin = false;
    } else {
      this.showLogin = false;
      this.route.queryParamMap.subscribe(params => {
        // User is not authenticated to access the route
        if (!localStorage.getItem('authenticatedRoute')?.length && !localStorage.getItem('session')?.length) {
          localStorage.clear();
          this.showLogin = true;
          return;
        }
        const token = params.get('token');
        let storedToken = (localStorage.getItem('session') as string);
        // Stored token and token from URL are different
        if (token && token?.slice(token.length - 5) !== storedToken?.slice(storedToken.length - 5)) {
          localStorage.clear();
          storedToken = '';
          this.showLogin = true;
        }
      })
    }
  }

  /**
   * Authenticates the user to protect the routes specified in environment.ts
   */
  userAuthenticated() {
    localStorage.setItem('authenticatedRoute', this.authenticateRoute);
    this.showLogin = false;
  }

  toggleTheme() {
    const isDarkTheme = document.body.classList.contains('dark');

    if (isDarkTheme) {
      this.renderer.removeClass(document.body, 'dark');
      localStorage.setItem('theme', 'light');
    } else {
      this.renderer.addClass(document.body, 'dark');
      localStorage.setItem('theme', 'dark');
    }
  }

  ngOnDestroy(): void {
    localStorage.clear();
  }
}
